import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import {
    Row,
    Col
} from 'react-bootstrap'
import * as styles from './Submarine.module.css'

const ExecutiveOfficer = () => {
    const data = useStaticQuery(graphql`
    {
      Xo: file(relativePath: { eq: "Whitaker-John_LCDR_042123.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 330, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <>
        <Row style={{
            backgroundColor: 'white',
            borderRadius: '5px',
            padding: '2rem',
        }}>
            <Col sm={9} className={styles.leadership}>
            <h2>Executive Officer</h2>
            <h3>Lieutenant Commander John Whitaker, PhD</h3>
            <hr style={{borderColor: 'rgba(0, 0, 0, 0.25)'}}/>
            <p>LCDR Whitaker is a native of Aberdeen, Washington.  He completed his undergraduate studies at Washington State University (B.S., Chemistry) and follow-on graduate studies at The Scripps Research Institute (Ph.D., Chemistry).  Following his academic endeavors, he joined the Nuclear Propulsion Officer Candidate (NUPOC) program and was commissioned via Officer Candidate School in 2012.</p>
            <p>He served as a Division Officer onboard USS Hampton (SSN 767), where following a Western Pacific Deployment he conducted a homeport shift from San Diego, California to Portsmouth, New Hampshire via the North Pole, participating in Ice Exercice (ICEX) 2016.  As Engineer Officer on USS Santa Fe (SSN 763) he completed an Engineered Overhaul in Portsmouth, New Hampshire and subsequent homeport shift to San Diego, California via the Panama Canal – finishing his circumnavigation of North America.</p>
            <p>Ashore, he served at the Pentagon on the staff of the Chief of Naval Operations (OPNAV) as Nuclear Weapons and Arms Control Policy Action Officer (N514) and later then Executive Assistant to the Assistant Deputy Chief of Naval Operations for Operations, Plans, and Strategy (N3/N5B).  Most recently he served on the staff of Commander, Submarine Squadron (COMSUBRON) FOUR as the Squadron’s Engineer and Materials Officer in Groton, Connecticut.</p>
            <p>LCDR Whitaker reported as Executive Officer on PCU IDAHO (SSN 799) in September 2025.</p>
            <p>His awards include the Meritorious Service Medal, Navy Commendation Medal (four awards), Navy Achievement Medal, and several unit awards shared with shipmates.</p>
            </Col>
            <Col md={3}>
                <Img fluid={data.Xo.childImageSharp.fluid} alt="Lieutenant Commander John Whitaker, PhD" className="rounded" />
            </Col>
        </Row>
    </>
  )
}

export default ExecutiveOfficer